/* digi-framework.js — base runtime for every DIGI module. Namespaced, no globals beyond window.DIGI.
   Provides: help tooltips, scoped error capture (module name + version, no PII), version beacon. ~2KB. */
(() => {
  if (window.DIGI) return;
  const runtimeEl = document.getElementById('digi-runtime');
  const runtime = runtimeEl ? JSON.parse(runtimeEl.textContent) : { version: '0.0.0' };

  /* ---- error capture, scoped to DIGI modules only (never other people's JS) ---- */
  const report = (module, error, extra) => {
    const payload = { module, version: runtime.version, shop: runtime.shop, url: location.pathname, message: String(error && error.message || error), extra };
    (window.DIGI.errors = window.DIGI.errors || []).push(payload);
    if (window.DIGI.endpoint) navigator.sendBeacon?.(window.DIGI.endpoint, JSON.stringify(payload));
    console.warn('[DIGI]', module, payload.message);
  };
  const guard = (module, fn) => { try { fn(); } catch (e) { report(module, e); } };

  window.DIGI = { version: runtime.version, guard, report, endpoint: null, modules: {} };

  /* ---- "?" help tooltips: one delegated listener for the whole page ---- */
  const closeAll = (except) => document.querySelectorAll('[data-digi-help]').forEach((h) => {
    if (h === except) return;
    h.querySelector('.digi-help__pop').hidden = true;
    h.querySelector('.digi-help__btn').setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-digi-help-close]');
    const btn = e.target.closest('.digi-help__btn');
    if (close) { const h = close.closest('[data-digi-help]'); closeAll(); h.querySelector('.digi-help__btn').focus(); return; }
    if (!btn) { closeAll(); return; }
    const help = btn.closest('[data-digi-help]');
    const pop = help.querySelector('.digi-help__pop');
    const open = pop.hidden;
    closeAll(help);
    pop.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open) pop.querySelector('.digi-help__close').focus();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('.digi-help__pop:not([hidden])');
    if (!open) return;
    const help = open.closest('[data-digi-help]');
    closeAll();
    help.querySelector('.digi-help__btn').focus();
  });
})();
